import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useRecoilState } from 'recoil';

import { NewRegulatoryTrainingLinkIndicators } from '@/components/molecules/NewRegulatoryTrainingLinkIndicators';
import { NewRegulatoryTrainingMatrix } from '@/components/molecules/NewRegulatoryTrainingMatrix';
import { NewRegulatoryTrainingMatrixPageHeader } from '@/components/molecules/NewRegulatoryTrainingMatrixPageHeader';
import NewSideFilter from '@/components/molecules/NewSideFilter';
import { filters } from '@/constants/filters/NewRegulatoryTrainingMatrixFilter';
import { useRegulatoryTrainingMatrix } from '@/hooks/useNewRegulatoryTrainingMatrix';
import { newRegulatoryTrainingMatrixFilterAtom } from '@/state/NewRegulatoryTrainingMatrixFilter.atom';

export const NewRegulatoryTrainingMatrixPage = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [, setFilters] = useRecoilState(newRegulatoryTrainingMatrixFilterAtom);
	const {
		filters: { options: filtersOptions, isLoading: isLoadingFiltersOptions },
	} = useRegulatoryTrainingMatrix();

	useEffect(() => {
		const trainingParam = searchParams.get('treinamento');
		const trainingId = trainingParam ? Number(trainingParam) : NaN;

		if (!Number.isNaN(trainingId)) {
			setFilters((prev) => ({
				...prev,
				training: [trainingId],
			}));
		}

		searchParams.delete('treinamento');
		searchParams.delete('polo');
		setSearchParams(searchParams);
	}, []);

	return (
		<>
			<NewSideFilter
				filters={filters}
				atom={newRegulatoryTrainingMatrixFilterAtom}
				options={filtersOptions}
				isLoading={isLoadingFiltersOptions}
			/>
			<NewRegulatoryTrainingMatrixPageHeader />

			<div className="w-full overflow-hidden gap-3 flex flex-col relative py-1">
				<NewRegulatoryTrainingLinkIndicators />
				<NewRegulatoryTrainingMatrix />
			</div>
		</>
	);
};
